import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Env } from '@dma/config';

let clientInstance: SupabaseClient | null = null;

/**
 * Lazily creates a single shared Supabase client instance per Lifetime
 * Management rules (docs/architecture/01-dependency-injection-strategy.md):
 * Repositories are Singleton for the lifetime of the app.
 * Only the public anon key is ever used here — per Security Architecture,
 * the service role key must never appear in client-side code.
 */
export function getSupabaseClient(env: Env): SupabaseClient {
  if (!clientInstance) {
    clientInstance = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY);
  }
  return clientInstance;
}
